<template>
  <div class="temp-style">
    <h2>通用模板</h2>
    <el-row>
      <h4>基础信息</h4>
      <el-form
        ref="formData"
        :inline="false"
        :model="formData"
      >
        <el-col
          v-for="(item, index) in baseMessageList"
          :key="index"
          :span="item.colSpan"
        >
          <el-form-item
            :label="item.fieldDisplayName + ':'"
            :prop="item.propKey"
            label-width="110px"
            :rules="[
              {
                required: item.attributeType === '输入框' && item.isRequired,
                message: `${item.fieldDisplayName}不能为空`
              }
            ]"
          >
            <el-input
              v-if="item.fieldDisplayName === '备注'"
              v-model="formData[item.propKey]"
              type="textarea"
              :rows="2"
              disabled
              placeholder="请输入"
            />
            <div v-else>
              <el-input
                v-if="item.attributeType === '输入框'"
                v-model="formData[item.propKey]"
                disabled
                placeholder="请输入"
              />
              <p v-else>
                {{ formData[item.propKey] }}
              </p>
            </div>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <h4>客户信息</h4>
    <div class="client-container">
      <ul>
        <li v-for="(item, index) in clientInfo" :key="index" class="flex flex-align">
          <div class="client-item flex flex-align flex-1">
            <label>收货信息标题{{ index + 1 }}：</label>
            <el-input v-model="item.title" disabled placeholder="请输入收货信息标题" />
          </div>
          <div class="last client-item flex flex-align flex-1">
            <label>收货信息内容{{ index + 1 }}：</label>
            <el-input v-model="item.content" disabled placeholder="请输入收货信息内容" />
          </div>
          <div class="operate-style flex">
            <i class="iconfont el-icon-plus" />
            <i class="iconfont el-icon-minus" />
          </div>
        </li>
      </ul>
    </div>

    <div class="flex flex-align product-style">
      <h4>产品信息</h4>
      <el-button type="primary" class="btn-style">
        复制头客户信息到勾选产品行上
      </el-button>
      <el-button type="default" class="btn-style">
        清空勾选产品的客户信息
      </el-button>
    </div>
    <el-table
      ref="tableDataRef"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column fixed="left" label="序号" align="left" type="index" />
      <el-table-column
        v-for="(item, index) in productHeaderList"
        :key="index"
        :prop="item.fieldKey"
        :label="item.fieldDisplayName"
        align="left"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-input
            v-if="item.attributeType === '输入框'"
            v-model="scope.row[item.key]"
            placeholder="请输入"
          />
          <span v-else>
            {{ scope.row[item.key] }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { parseTime } from '@/libs/util.js';
import { viewTemplate } from '@/API/markManager.js';

export default {
  data () {
    return {
      tempId: '',
      formData: {},
      selectList: [],
      baseType: 'markField',
      baseMessageList: [], // 基础信息
      clientInfo: [{}], // 客户信息
      productHeaderList: [], // 产品信息Table头数据
      tableData: [] // 产品信息数据
    };
  },

  mounted () {
    this.initData();
  },

  methods: {
    initData () {
      viewTemplate({
        id: ''
      }).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          // 基础信息的处理
          this.baseMessageList = (data.baseMessageList || []).map(item => {
            const val = () => {
              if (item.fieldKey === 'createTime') {
                return parseTime(new Date());
              } else if (item.fieldKey === 'createName') {
                return this.$store.state.user?.userName;
              }
              return item.defaultValue || '';
            };
            this.$set(this.formData, `${this.baseType}${item.fieldOrder}`, val());
            item.propKey = `${this.baseType}${item.fieldOrder}`;
            return {
              ...item,
              colSpan: ['remark'].indexOf(item.fieldKey) > -1 ? 24 : 8
            };
          });

          // 产品信息的 Table Header头数据处理
          this.productHeaderList = data.productHeaderList || [];

          // 产品信息的 Table 表格数据处理
          this.tableData = data.productDefaultValueList || [];
          this.isLoading = false;
        }
      }).catch(e => {
        this.isLoading = false;
      });
    }
  }
};
</script>

<style lang="scss">
.temp-style {
  .el-dialog__body {
    padding: 20px !important;
    min-height: 300px !important;
  }
  .el-main {
    min-height: 300px !important;
  }
}
</style>

<style lang="scss" scoped>
.temp-style {
  .flex {
    display: flex;
  }
  .flex-align {
    align-items: center;
  }
  .flex-1 {
    flex: 1;
  }
  .el-col {
    min-height: 40px;
  }
  h4 {
    margin: 10px 0;
  }
  .product-style {
    margin: 12px 0;
    .btn-style {
      margin-left: 20px;
    }
  }
  .client-container {
    >ul {
      list-style: none;
      li {
        padding-bottom: 12px;
        .last {
          margin-left: 12px;
        }
        .client-item {
          >label {
            width: 150px;
            font-size: 13px;
            text-align: right;
            padding-right: 12px;
          }
        }
        .operate-style {
          width: 140px;
          justify-content: space-evenly;
          font-weight: 800;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
